/**
 * @generated SignedSource<<caf356cc29b3d272f1ec951d78b4f77b>>
 * @relayHash d37f1edf760d6fdc5aa0c58ba55117bf
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID f29baaf873d467f85ad5668782754386b1855edef2b80c21485eb7ae50dfddb7

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { src_jiraBoardQuery } from './src_jiraBoardQuery.graphql';

const node: PreloadableConcreteRequest<src_jiraBoardQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "f29baaf873d467f85ad5668782754386b1855edef2b80c21485eb7ae50dfddb7",
    "metadata": {},
    "name": "src_jiraBoardQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
